/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function HourglassLow(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M200,75.64111V40a16.01833,16.01833,0,0,0-16-16H72A16.01833,16.01833,0,0,0,56,40V76a16.07589,16.07589,0,0,0,6.3999,12.7998L114.667,128l-52.2666,39.2002a16.06134,16.06134,0,0,0-6.34814,11.92236A7.943,7.943,0,0,0,56,180v36a16.01833,16.01833,0,0,0,16,16H184a16.01833,16.01833,0,0,0,16-16V180.35889a8.04861,8.04861,0,0,0-.05273-.89307,16.06854,16.06854,0,0,0-6.29932-11.87061L141.2666,128l52.38184-39.595A16.08467,16.08467,0,0,0,200,75.64111ZM82.59717,172.052l45.38428-34.03784,45.36572,34.29248ZM184,75.64136l-56.01855,42.34448L72,76V40H184Z" />
    </Svg>
  );
}

export default HourglassLow;
